import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'
import rpcCall from '../../util/rpc/rpcCalls'

export const setLoading = createAction(ActionTypes.LOADING_SET)

export const setTeamNames = createAction(ActionTypes.TEAM_NAMES_SET)

export const setNeedToLoadData = createAction(ActionTypes.NEED_TO_LOAD_DATA_SET)

export const loadAssignedTeamNames = () => (dispatch) => {
    dispatch(setLoading(true))
    rpcCall("UserProfileService.getTeamListInfo", [])
        .then(data => {
            dispatch(setTeamNames(data.teamNames))
            dispatch(setNeedToLoadData(false))
            dispatch(setLoading(false))
        })
        .catch(() => {
            dispatch(setLoading(false))
        })
}

export const openTeamList = () => (dispatch) => {
    dispatch(setNeedToLoadData(true))
}


// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/actions.js